import { Delete as DeleteIcon } from '@mos-cat/ds-icons';
import { pxToRem } from '@mos-cat/ds-theme';
import { Box } from '../../../../Box/Box';
import { Button } from '../../../../Button/Button';

type DeleteFileProps = {
  fileName: string;
  onDeleteClick: () => void;
};

export function DeleteFile({ fileName, onDeleteClick }: DeleteFileProps) {
  return (
    <Box alignSelf="center">
      <Box
        as={Button}
        vertSize="40"
        type="button"
        kind="borderless"
        onClick={onDeleteClick}
        aria-label={`Удалить ${fileName}`}
      >
        <Box
          minWidth={pxToRem(38)}
          display="flex"
          justifyContent="center"
          alignItems="center"
          styles={{
            '& svg': {
              size: ['fileUploaderBtnIconSize', 'fileUploaderBtnIconSizeBig'],
            },
          }}
        >
          <Box as={DeleteIcon} my="-sp-2" />
          <Box ml="fileRemoveBtnIconOffset" display={['none', 'block']}>
            Удалить
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
